import React, { Component } from 'react'
import Img from 'gatsby-image'
import './style.sass'

export default class Footer extends Component {
  render() {
    const logoLugerna = this.props.images.find(
      image => image.node.sizes.src.indexOf('footer-lugerna') >= 0
    )
    const logoUsi = this.props.images.find(
      image => image.node.sizes.src.indexOf('footer-usi') >= 0
    )
    const logoAdm = this.props.images.find(
      image => image.node.sizes.src.indexOf('footer-adm') >= 0
    )
    const logoSorbonne = this.props.images.find(
      image => image.node.sizes.src.indexOf('footer-sorbonne') >= 0
    )
    const logoUnimilano = this.props.images.find(
      image => image.node.sizes.src.indexOf('footer-uniMilano') >= 0
    )
    const logoCattolica = this.props.images.find(
      image => image.node.sizes.src.indexOf('footer-cattolica') >= 0
    )
    const logoPolitecnico = this.props.images.find(
      image => image.node.sizes.src.indexOf('footer-politecnico') >= 0
    )
    const logoInnsbruck = this.props.images.find(
      image => image.node.sizes.src.indexOf('footer-innsbruck') >= 0
    )
    const logoFns = this.props.images.find(
      image => image.node.sizes.src.indexOf('footer-centraleFns') >= 0
    )
    const logoOaw = this.props.images.find(
      image => image.node.sizes.src.indexOf('footer-oaw') >= 0
    )

    return (
      <footer className="Footer">
        <div className="Footer__Mobile">
          <div className="Footer__Section--mobile">
            <div className="Footer__Mobile__Row">
              <div className="LogoPrimaRiga" style={{ flex: 1 }}>
                <Img sizes={logoUsi.node.sizes} />
              </div>
              <div className="LogoPrimaRiga" style={{ flex: 2 }}>
                <Img sizes={logoAdm.node.sizes} />
              </div>
            </div>
            <div className="Footer__Mobile__Row">
              <div className="LogoPrimaRiga" style={{ flex: 1 }}>
                <Img sizes={logoLugerna.node.sizes} />
              </div>
              <div className="LogoPrimaRiga" style={{ flex: 2 }}>
                <Img sizes={logoSorbonne.node.sizes} />
              </div>
            </div>
          </div>
          <div className="Footer__Section--mobile">
            <div
              style={{
                margin: '0 auto',
                width: '300px',
              }}
            >
              <div className="Footer__Heading">Contatti</div>

              <div className="text-white">
                <div>Telefono: + 4 1 58 666 55 00</div>
                <div>Mail: archivio.arc@usi.ch</div>
                <div>Website: www.archiviodelmoderno.org</div>
                <div>Via Magazzini Generali 14</div>
                <div>6828 Balerna (Svizzera)</div>
              </div>

              <div className="Footer__Heading" style={{ marginTop: '2rem' }}>
                Partner
              </div>

              <div className="Footer__Partner__Row">
                <div className="LogoPrimaRiga" style={{ flex: 3 }}>
                  <Img sizes={logoUnimilano.node.sizes} />
                </div>
                <div className="LogoPrimaRiga" style={{ flex: 1 }}>
                  <Img sizes={logoCattolica.node.sizes} />
                </div>
              </div>
              <div
                className="Footer__Partner__Row"
                style={{ justifyContent: 'start' }}
              >
                <div className="LogoPrimaRiga" style={{ flex: 3 }}>
                  <Img sizes={logoPolitecnico.node.sizes} />
                </div>
                <div style={{ flex: 1 }} />
              </div>
              <div className="Footer__Partner__Row">
                <div className="LogoPrimaRiga" style={{ flex: 1 }}>
                  <Img sizes={logoOaw.node.sizes} />
                </div>

                <div className="LogoPrimaRiga" style={{ flex: 3 }}>
                  <Img sizes={logoInnsbruck.node.sizes} />
                </div>
              </div>
            </div>
          </div>

          <div className="Footer__Section--mobile">
            <div
              className="LogoPrimaRiga"
              style={{ width: '300px', margin: '0 auto' }}
            >
              <Img sizes={logoFns.node.sizes} />
            </div>
          </div>
        </div>

        <div className="Footer__Desktop">
          <div className="Footer__Section">
            <div className="wrap-narrower Footer__LoghiPrimaRiga">
              <div className="LogoPrimaRiga" style={{ flex: 1 }}>
                <Img
                  sizes={logoUsi.node.sizes}
                  imgStyle={{
                    bottom: 0,
                    top: 'auto',
                    height: '74%',
                    width: 'auto',
                  }}
                />
              </div>
              <div className="LogoPrimaRiga" style={{ flex: 2 }}>
                <Img sizes={logoAdm.node.sizes} />
              </div>
              <div className="LogoPrimaRiga" style={{ flex: 1 }}>
                <Img
                  sizes={logoLugerna.node.sizes}
                  imgStyle={{
                    width: '90%',
                    height: 'auto',
                  }}
                />
              </div>
              <div className="LogoPrimaRiga" style={{ flex: 2 }}>
                <Img sizes={logoSorbonne.node.sizes} />
              </div>
            </div>
          </div>

          <div className="Footer__Section">
            <div className="wrap-narrower">
              <div className="Footer__Row">
                <div className="Footer__Left">
                  <div className="Footer__Heading">Contatti</div>

                  <div className="text-white">
                    <div>Telefono: + 4 1 58 666 55 00</div>
                    <div>Mail: archivio.arc@usi.ch</div>
                    <div>Website: www.archiviodelmoderno.org</div>
                    <div>Via Magazzini Generali 14</div>
                    <div>6828 Balerna (Svizzera)</div>
                  </div>
                </div>
                <div className="Footer__Right Footer__Partner">
                  <div className="Footer__Heading">Partner</div>

                  <div className="Footer__Partner__Row">
                    <div className="LogoPrimaRiga" style={{ flex: 3 }}>
                      <Img sizes={logoUnimilano.node.sizes} />
                    </div>
                    <div className="LogoPrimaRiga" style={{ flex: 1 }}>
                      <Img
                        sizes={logoCattolica.node.sizes}
                        imgStyle={{
                          height: '90%',
                          width: 'auto',
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className="Footer__Partner__Row"
                    style={{ justifyContent: 'start' }}
                  >
                    <div className="LogoPrimaRiga" style={{ flex: 3 }}>
                      <Img sizes={logoPolitecnico.node.sizes} />
                    </div>
                    <div style={{ flex: 1 }} />
                  </div>
                  <div className="Footer__Partner__Row">
                    <div className="LogoPrimaRiga" style={{ flex: 1 }}>
                      <Img sizes={logoOaw.node.sizes} />
                    </div>
                    <div className="LogoPrimaRiga" style={{ flex: 3 }}>
                      <Img sizes={logoInnsbruck.node.sizes} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="Footer__Section" style={{ padding: '4rem' }}>
            <div className="wrap-narrower Footer__Row">
              <div style={{ flex: 1 }} />
              <div className="LogoPrimaRiga" style={{ flex: 1 }}>
                <Img sizes={logoFns.node.sizes} />
              </div>
              <div style={{ flex: 1 }} />
            </div>
          </div>
        </div>
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/footer/index.js